import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import FeedbackPage from './pages/FeedbackPage';
import DocumentsPage from './pages/DocumentsPage';
import ForumPage from './pages/ForumPage';
import CountyOfficerPage from './pages/CountyOfficerPage';
import WardOfficerPage from './pages/WardOfficerPage';
import ManagerPage from './pages/ManagerPage';
import CommunityVolunteerPage from './pages/CommunityVolunteerPage';
import VolunteerApplicationPage from './pages/VolunteerApplicationPage';
import './App.css';

function App() {
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('user') || 'null'));
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Register service worker for offline support
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then(() => console.log('SW registered'))
        .catch(() => console.log('SW registration failed'));
    }

    // Handle online/offline status
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <nav className="navbar"> 
          <div>
            <div className="nav-brand">
              <Link to="/">
                <img src="/turkana.jpg" alt="Turkana County" style={{width: '24px', height: '24px', marginRight: '8px'}} />
                Turkana Budgets and Accountability Platform
              </Link>
              {!isOnline && <span className="offline-indicator">🔴 Offline</span>}
            </div>
            <div className="nav-links">
              <Link to="/">Home</Link>
              <Link to="/dashboard">Projects & Analytics</Link>
              <Link to="/documents">Documents</Link>
              <Link to="/forum">Forum</Link>
              <Link to="/feedback" className={user ? 'feedback-link-authenticated' : 'feedback-link-public'}>Feedback</Link>
              {user ? (
                <>
                  {(user.role === 'system_admin') && (
                    <Link to="/admin">System Admin</Link>
                  )}
                  {(user.role === 'manager') && (
                    <Link to="/manager">Manager Dashboard</Link>
                  )}
                  {(user.role === 'county_officer') && (
                    <Link to="/county-officer">Institutional Responder</Link>
                  )}
                  {(user.role === 'ward_officer') && (
                    <Link to="/ward-officer">Civic Moderator</Link>
                  )}
                  {(user.role === 'community_volunteer') && (
                    <Link to="/volunteer">Community Volunteer</Link>
                  )}
                  <span className="user-info">
                    {user.name} · {{
                      system_admin: 'System Administrator',
                      manager: 'Manager',
                      county_officer: 'Institutional Responder',
                      ward_officer: 'Civic Moderator',
                      community_volunteer: 'Community Volunteer'
                    }[user.role as string] || user.role}
                  </span>
                  <button 
                    onClick={() => {
                      localStorage.removeItem('token');
                      localStorage.removeItem('user');
                      setUser(null);
                      window.location.href = '/';
                    }}
                    className="logout-btn"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <Link to="/login" className="login-link">User Login</Link>
              )}
            </div>
          </div>
        </nav>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/documents" element={<DocumentsPage />} />
            <Route path="/documents/:filename" element={<DocumentsPage />} />
            <Route path="/forum" element={<ForumPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="/county-officer" element={<CountyOfficerPage />} />
            <Route path="/ward-officer" element={<WardOfficerPage />} />
            <Route path="/manager" element={<ManagerPage />} />
            <Route path="/volunteer" element={<CommunityVolunteerPage />} />
            <Route path="/volunteer-apply" element={<VolunteerApplicationPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;